import { API_BASE } from '../../config/api';

async function parseJson(response) {
    const text = await response.text();
    if (!text) return {};
    try {
        return JSON.parse(text);
    } catch (_error) {
        return { raw: text };
    }
}

export async function apiRequest(path, options = {}) {
    const url = path.startsWith('http') ? path : `${API_BASE}${path}`;
    const response = await fetch(url, options);
    const body = await parseJson(response);

    if (!response.ok) {
        throw new Error(body.error || `HTTP ${response.status}`);
    }

    if (body && typeof body === 'object' && body.success === false) {
        throw new Error(body.error || 'API request failed');
    }

    return body;
}
